// extracted by mini-css-extract-plugin
export default {"container":"receiptFailer_container__3BX3F"};